import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface AssistantModalState {
  isOpen: boolean;
  /** The event (balloon) the conversation is scoped to, if any. */
  balloonId?: string | null;
  open: (balloonId?: string | null) => void;
  close: () => void;
}

const AssistantModalContext = createContext<AssistantModalState | null>(null);

export const AssistantModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [balloonId, setBalloonId] = useState<string | null | undefined>(undefined);

  const open = useCallback((scopedBalloonId?: string | null) => {
    setBalloonId(scopedBalloonId ?? null);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <AssistantModalContext.Provider value={{ isOpen, balloonId, open, close }}>
      {children}
    </AssistantModalContext.Provider>
  );
};

export function useAssistantModal(): AssistantModalState {
  const context = useContext(AssistantModalContext);
  if (!context) {
    throw new Error('useAssistantModal must be used within an AssistantModalProvider');
  }
  return context;
}

export function useAssistantModalSafe(): AssistantModalState | null {
  return useContext(AssistantModalContext);
}
